import { BorderRadius, Color, getDefaultTransition, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

interface RadioButtonSectionWrapperProps {
  checked?: boolean
  htmlFor: string
}

export const RadioButtonSectionWrapper = styled.label<RadioButtonSectionWrapperProps>`
  display: flex;
  padding: ${Spacing.S12};
  border: 1px solid ${({ checked }) => (checked ? Color.Black : Color.Grey150)};
  border-radius: ${BorderRadius.R12};
  position: relative;
  ${({ checked }) => checked && `box-shadow: 0 2px 4px 0 ${transparentize(0.8, Color.Grey300)};`};

  cursor: pointer;
  ${getDefaultTransition('box-shadow', 'background-color')};

  &:hover {
    border: 1px solid ${({ checked }) => (checked ? Color.Black : Color.Grey300)};
    box-shadow: 0 2px 4px 0 ${transparentize(0.8, Color.Grey300)};
  }
`

export const LeftSection = styled.aside`
  display: flex;
`

interface RadioControlProps {
  checked?: boolean
}

export const RadioControl = styled.span<RadioControlProps>`
  display: flex;
  width: 20px;
  height: 20px;
  margin-top: ${Spacing.S2};
  margin-right: ${Spacing.S12};
  border: ${({ checked }) => (checked ? 'none' : `1px solid ${Color.Grey200}`)};
  border-radius: 50%;
  background-color: ${({ checked }) => (checked ? Color.Lavender500 : 'transparent')};
  box-shadow: ${({ checked }) => (checked ? 'none' : `0 2px 4px 0 ${transparentize(0.7, Color.Grey300)}`)};
  ${getDefaultTransition('background-color', 'opacity')}

  /* pseudo-element below was added to visualise the inside circle of the RadioControl element when it's selected */
  &:after {
    content: '';
    opacity: ${({ checked }) => (checked ? '1' : '0')};
    width: 8px;
    height: 8px;
    margin: auto;
    border-radius: 50%;
    background-color: ${Color.Black};
    ${getDefaultTransition('background-color', 'opacity')}
  }
`

export const NativeRadio = styled.input`
  opacity: 0;
  width: 1px;
  height: 1px;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
`
